import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getDefaultServiceIntakeQuestions } from '../../services/business';

function useGetDefaultServiceIntakeQuestions() {
  const { user } = useUser();

  const { data, isLoading } = useQuery({
    queryKey: ['defaultServiceIntakeQuestions', user?.business?.id],
    queryFn: async () => {
      if (!user?.business?.id) return null;
      return getDefaultServiceIntakeQuestions(user.business.id);
    },
    enabled: !!user?.business?.id,
  });

  return {
    defaultQuestions: data ?? [],
    isLoading,
  };
}

export default useGetDefaultServiceIntakeQuestions;
